import { Pinia, Store } from 'pinia-class-component';
import { GroupSurveyExtension, GroupSurveyExtensionUiClient } from '../components/backend/backendapi';
import { initClient } from '../api';

@Store({
  id: 'GroupSurveyExtensionStore',
  name: 'GroupSurveyExtensionStore',
})
export default class GroupSurveyExtensionStore extends Pinia {
  private readonly api = initClient(GroupSurveyExtensionUiClient);

  //data
  private _loadingPromise: Promise<GroupSurveyExtension[]> | null = null;
  private _groupSurveyExtensions: GroupSurveyExtension[] = [];

  //getter
  get loading(): boolean {
    return this._loadingPromise !== null;
  }

  get groupSurveyExtensions(): GroupSurveyExtension[] {
    return this._groupSurveyExtensions;
  }

  get groupSurveyExtensionsById(): Map<string, GroupSurveyExtension> {
    return new Map(this._groupSurveyExtensions.map(e => [e.id, e]));
  }

  //actions
  clear(): void {
    this._groupSurveyExtensions.splice(0);
  }

  setGroupSurveyExtensions(groupSurveyExtensions: GroupSurveyExtension[]): void {
    this._groupSurveyExtensions.splice(0);
    this._groupSurveyExtensions.push(...groupSurveyExtensions);
  }

  rememberGroupSurveyExtension(groupSurveyExtension: GroupSurveyExtension): void {
    const index = this._groupSurveyExtensions.findIndex(e => e.id === groupSurveyExtension.id);
    if (index >= 0) {
      this._groupSurveyExtensions.splice(index, 1, groupSurveyExtension);
    } else {
      this._groupSurveyExtensions.push(groupSurveyExtension);
    }
  }

  forgetGroupSurveyExtension(groupSurveyExtension: GroupSurveyExtension): void {
    const index = this._groupSurveyExtensions.findIndex(e => e.id === groupSurveyExtension.id);
    if (index >= 0) {
      this._groupSurveyExtensions.splice(index, 1);
    }
  }

  async reload(force: boolean = false): Promise<void> {
    if (this._loadingPromise) {
      await this._loadingPromise;
      if (!force) {// when force is true, wait for the current operation to complete, then reload
        return;
      }
    }

    try {
      this._loadingPromise = this.api.list(null, null, null, null);
      const groupSurveyExtensions = await this._loadingPromise;
      this.setGroupSurveyExtensions(groupSurveyExtensions);
    } catch (err) {
      this.clear();
    } finally {
      this._loadingPromise = null;
    }
  }

  async loadIfAbsent(): Promise<void> {
    if (this._groupSurveyExtensions.length > 0) {
      return;
    }
    return await this.reload();
  }
}